import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
function defaultRenderValue(option, selectProps) {
  const { icon, label } = option ?? {};
  const { displayEmpty } = selectProps;
  const isEmpty = !option || !option.value;
  if (isEmpty && displayEmpty) return /* @__PURE__ */ jsx(Box, { minWidth: 40 });
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      direction: "row",
      gap: 1,
      sx: { alignItems: "center", justifyContent: "left" },
      "data-testid": "select-input-container",
      children: [
        !!icon && /* @__PURE__ */ jsx(Box, { component: "span", sx: { display: "flex", alignItems: "center" }, children: icon }),
        label
      ]
    }
  );
}
export {
  defaultRenderValue
};
//# sourceMappingURL=defaultRenderValue.js.map
